const sectionTitleIcons = {
  contact: {
    src: '/static/img/website/big/icons/section-title/contact.svg',
    alt: 'illustration of an envelope'
  },
  customers: {
    src: '/static/img/website/big/icons/section-title/customers.svg',
    alt: 'illustration of shapes'
  },
  datasets: {
    src: '/static/img/website/big/icons/section-title/datasets.svg',
    alt: 'illustration for Datasets'
  },
  datasetsDark: {
    src: '/static/img/website/big/icons/section-title/datasets-dark.svg',
    alt: 'illustration for Datasets'
  },
  enterpriseReady: {
    src: '/static/img/website/big/icons/section-title/enterprise-ready.svg',
    alt: 'illustration of a city'
  },
  money: {
    src: '/static/img/website/big/icons/section-title/money.svg',
    alt: 'illustration of money'
  },
  qualityAssurance: {
    src: '/static/img/website/big/icons/section-title/quality-assurance.svg',
    alt: 'illustration of shapes'
  },
  useCases: {
    src: '/static/img/website/big/icons/section-title/use-cases.svg',
    alt: 'illustration of shapes'
  },
  howItWorks: {
    src: '/static/img/website/big/icons/section-title/how-it-works.svg',
    alt: 'illustration of shapes'
  },
  howItWorksDark: {
    src: '/static/img/website/big/icons/section-title/how-it-works-dark.svg',
    alt: 'illustration of shapes'
  },
  clipboard: {
    src: '/static/img/website/big/icons/section-title/clipboard.svg',
    alt: 'illustration of Clipboard'
  },
  whyScale: {
    src: '/static/img/website/big/icons/section-title/why-scale.svg',
    alt: 'illustration of Why Scalee'
  }
};

export default sectionTitleIcons;
